<template>
    <div class="goals">
        <div v-if="goals" >

            <definition-parser>
                <h1>Dit ga je leren</h1>
                <ul class="goals-content" >
                    <li v-for="goal in goals">{{ goal }}</li>
                </ul>
            </definition-parser>

        </div>

        <div class="assignment-seq" v-if="successors.length || predecessors.length">

            <hr>

            <template v-if="successors.length">
                <h2 class="banner"><span>Opdracht bereidt voor op:</span></h2>
                <router-link
                    :to="{ name: 'assignment', params: { assignmentId: assignment.id} }"
                    v-for="assignment in successors"
                    :key="assignment.id"
                    @click.native="$emit('close')"
                    class="assignment-seq__related assignment-seq__related--successor" >

                    <img :src="assignment.image" :alt="assignment.title" class="assignment-seq__hero" />
                    <span class="assignment-seq__title tag">{{ assignment.title }}</span>

                </router-link>
            </template>

            <template v-if="predecessors.length">
                <h2 class="banner"><span>Opdracht valt terug op:</span></h2>
                <router-link
                    :to="{ name: 'assignment', params: { assignmentId: assignment.id} }"
                    v-for="assignment in predecessors"
                    :key="assignment.id"
                    @click.native="$emit('close')"
                    class="assignment-seq__related assignment-seq__related--predecessor" >

                    <img :src="assignment.image" :alt="assignment.title" class="assignment-seq__hero" />
                    <span class="assignment-seq__title tag">{{ assignment.title }}</span>

                </router-link>
            </template>

        </div>
    </div>
</template>


<script>
import DefinitionParser from './DefinitionParser.vue'
import api from 'js/api/resources'
import { transform } from 'js/vuex/helpers'

export default {
    props: {
        assignment: {
            required: true,
        },
    },

    components: { DefinitionParser },

    data: function() {
        return {
            predecessors: [],
            successors: [],
        }
    },

    computed: {
        goals: function() {
            return this.assignment.goals
        },
    },

    created: function() {

        api.getAssignmentSequence(this.assignment.id)
            .then( response => transform(response.body))
            .then( result => {
                const assignments = result.assignments || []
                const current = assignments.find(a => a.id == this.assignment.id)
                this.predecessors = current.predecessors
                    .map( id => assignments.find( a => a.id == id ))
                    .filter( a => a != null )
                this.successors = current.successors
                    .map( id => assignments.find( a => a.id == id ))
                    .filter( a => a != null )

            })

    },
}
</script>


<style lang="scss">

    @import 'global';

    .assignment-seq {

        text-align: center;

        &__related {
            width: 112px;
            padding: 0;
            margin: 10px 20px;
            display: inline-block;

            text-align: center;
            vertical-align: top;

        }

        &__hero {
            width: 75px !important;
            height: 75px;
            border: 0;
            margin: 0 !important;
            border-radius: 50%;
            display: inline-block !important;
        }

        &__title {
            display: block;
            margin: 0.2em 0;
        }

    }

</style>



// WEBPACK FOOTER //
// Goals.vue?59c71d09